import {LogLevel} from '../app/services/logger.service';

export const environment = {
  production: true,
  logLevel: LogLevel.Info,
  apiBaseUrl: 'https://api.sysprompthub.com',
  firebase: {
    apiKey: 'AIzaSyCMgBtYId5E9m8PyH7WVm1qgvv83E4GHrs',
    authDomain: 'sysprompthub.firebaseapp.com',
    projectId: "sysprompthub",
    storageBucket: "sysprompthub.firebasestorage.app",
    messagingSenderId: "477094013773",
    appId: "1:477094013773:web:8b66429654ce28fe536504",
    measurementId: "G-712PSJ4P66"
  }
};
